module.exports = __webpack_public_path__ + "static/media/PawelLewinski.ebeaebb0.png";